import { BN } from '@velocity-exchange/sdk';
import { PublicKey } from '@solana/web3.js';
import { DEFAULT_SWAP_SLIPPAGE_TOLERANCE_PCT } from 'src/constants/swap';

/**
 * Mainnet USDC. Not a Velocity spot market — only used for the wallet-side
 * "Swap & Deposit" flow (USDC → USDT via Jupiter, then deposit).
 */
export const USDC_MAINNET_MINT = new PublicKey(
	'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v'
);

export const USDC_PRECISION_EXP = new BN(6);

/**
 * USDC has no icon on the market-icon CDN (it's not a spot market there),
 * so its icon is vendored locally instead of going through `MarketIcon`.
 */
export const USDC_ICON_SRC = '/assets/markets/usdc.svg';

/**
 * Slippage tolerances to try at submit time, tightest first. USDC/USDT is deep
 * enough that the tightest rung nearly always simulates cleanly, so quoting the
 * whole flow at the generic 0.1% default would leave the user paying for
 * tolerance they don't need — slippage is also what bounds the wallet dust the
 * minOut deposit leaves behind.
 *
 * Each later rung costs a re-quote and a simulation, so the ladder stops at the
 * first rung that simulates. The intended 0.025% step gives 0.05 / 0.075 / 0.1;
 * 7.5 bps isn't expressible (Jupiter takes an integer slippageBps), so the
 * middle rung rounds up to 8. The top rung stays at the shared default, which
 * is the widest tolerance this flow will ever execute at.
 */
export const SWAP_AND_DEPOSIT_SLIPPAGE_LADDER_BPS: readonly number[] = [
	5,
	8,
	DEFAULT_SWAP_SLIPPAGE_TOLERANCE_PCT * 100,
];

/**
 * Slippage the displayed quote is fetched at — the tightest rung. Execution can
 * walk up from here, which only ever lowers the deposited minOut, never raises
 * it past a limit the UI already checked.
 */
export const SWAP_AND_DEPOSIT_SLIPPAGE_BPS =
	SWAP_AND_DEPOSIT_SLIPPAGE_LADDER_BPS[0];
